import React, { Suspense, lazy } from 'react';
import { Route, Outlet } from 'react-router-dom';

// -------------------------------------------------------------
// Core Components
// -------------------------------------------------------------
import ProtectedRoute from '../Components/ProtectedRoute';

// -------------------------------------------------------------
// Lazy Loaded Pages
// -------------------------------------------------------------
const Home = lazy(() => import('../Pages/Home'));
const CollaborativeLeadership = lazy(() => import('../Pages/CollaborativeLeadership'));
const CampusLeaders = lazy(() => import('../Pages/CampusLeaders'));
const Register = lazy(() => import('../Pages/Register'));
const ForgetPassword = lazy(() => import('../Pages/ForgetPassword'));
const PublicationList = lazy(() => import('../Pages/Publication/PublicationList'));
const PublicationDetail = lazy(() => import('../Pages/Publication/PublicationDetail'));
const ProgramIndex = lazy(() => import('../Pages/Program/ProgramIndex'));
const RegistrationsIndex = lazy(() => import('../Pages/Program/Registrations/RegistrationsIndex'));
const RegistrationsBumdes = lazy(() => import('../Pages/Program/Registrations/Bumdes'));
const RegistrationsOthers = lazy(() => import('../Pages/Program/Registrations/Others'));
const RegistrationsSuccess = lazy(() => import('../Pages/Program/Registrations/Success'));
const KpiDetails = lazy(() => import('../Pages/Program/KpiDetails'));
const EvaluationsFinalStudent = lazy(() => import('../Pages/Public/EvaluationsFinalStudent'));
const PreSurveyBumdes = lazy(() => import('../Pages/Public/PreSurveyBumdes'));
const RegisterBumdes = lazy(() => import('../Pages/Public/RegisterBumdes'));
const Unauthorized = lazy(() => import('../Pages/Unauthorized'));

const FallbackLoader = () => (
  <div className="d-flex justify-content-center align-items-center py-5" style={{ minHeight: "50vh" }}>
    <div className="spinner-border text-primary" role="status">
      <span className="visually-hidden">Loading...</span>
    </div>
  </div>
);

const publicRoutes = (authUser) => (
  <Route element={<Suspense fallback={<FallbackLoader />}><Outlet /></Suspense>}>
    <Route index element={<Home />} />
    <Route path='collaborative-leadership' element={<CollaborativeLeadership />} />
    <Route path='campus-leaders' element={<CampusLeaders />} />

    <Route path='public'>
      <Route path='evaluations-final/:id' element={<EvaluationsFinalStudent />} />
      <Route path='pre-survey' element={<PreSurveyBumdes />} />
    </Route>

    <Route path='articles'>
      <Route index element={<PublicationList />} />
      <Route path=':id' element={<PublicationDetail />} />
    </Route>

    <Route path='program'>
      <Route index element={<ProgramIndex />} />
      <Route path='kpi' element={<KpiDetails />} />
      
      <Route element={<ProtectedRoute />}>
        <Route path='registrations'>
          <Route index element={<RegistrationsIndex authUser={authUser} />} />
          <Route path='institutions' element={<RegistrationsBumdes />} />
          <Route path='others' element={<RegistrationsOthers />} />
          <Route path='success' element={<RegistrationsSuccess />} />
        </Route>
      </Route>
    </Route>

    <Route path='register' element={<Register />} />
    <Route path='bumdes/register' element={<RegisterBumdes />} />
    <Route path='forget-password' element={<ForgetPassword />} />
    <Route path='unauthorized' element={<Unauthorized />} />
  </Route>
);

export default publicRoutes;
